import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { IntervalPlanComponent } from './components/interval-plan/interval-plan.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { RoutesComponent } from './components/routes/routes.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { StationsComponent } from './components/stations/stations.component';
import { TrainsComponent } from './components/trains/trains.component';
import { WeeklySchedulesComponent } from './components/weekly-schedules/weekly-schedules.component';
import { SpecialDaysComponent } from './components/special-days/special-days.component';
import { PlansComponent } from './components/plans/plans.component';
import { UsersComponent } from './components/users/users.component';
import { SettingsComponent } from './components/settings/settings.component';
import { OperatorsComponent } from './components/operators/operators.component';
import { JobsComponent } from './components/jobs/jobs.component';
import { DisplayInfoTablesComponent } from './components/display-track-realization/display-info-tables.component';
import { RealizationComponent } from './components/realization/realization.component';
import { AudioMessagesComponent } from './components/audio-messages/audio-messages.component';
import { AudioControllerComponent } from './components/audio-controller/audio-controller.component';
import { InfoTableMonitorComponent } from './components/info-table-monitor/info-table-monitor.component';
import { BroadcastMessagesComponent } from './components/broadcast-messages/broadcast-messages.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      { path: 'home', component: HomeComponent },
      { path: 'stations', component: StationsComponent },
      { path: 'trains', component: TrainsComponent },
      { path: 'interval-plan', component: IntervalPlanComponent },
      { path: 'weekly-schedules', component: WeeklySchedulesComponent },
      { path: 'routes', component: RoutesComponent },
      { path: 'special-days', component: SpecialDaysComponent },
      { path: 'plans', component: PlansComponent },
      { path: 'users', component: UsersComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'operators', component: OperatorsComponent },
      { path: 'jobs', component: JobsComponent },
      { path: 'display-track-realization', component: DisplayInfoTablesComponent },
      { path: 'info-table-monitor', component: InfoTableMonitorComponent },
      { path: 'realization', component: RealizationComponent },
      { path: 'audio-messages', component: AudioMessagesComponent },
      { path: 'audio-controller', component: AudioControllerComponent },
      { path: 'broadcast-messages', component: BroadcastMessagesComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}

export const routerLinks = [
  NavbarComponent,
  HomeComponent,
  SidebarComponent,
  StationsComponent,
  TrainsComponent,
  IntervalPlanComponent,
  RoutesComponent,
  WeeklySchedulesComponent,
  SpecialDaysComponent,
  PlansComponent,
  WeeklySchedulesComponent,
  UsersComponent,
  SettingsComponent,
  OperatorsComponent,
  JobsComponent,
  DisplayInfoTablesComponent,
  RealizationComponent,
  AudioMessagesComponent,
];
